<template>
    <div class="page flex px-0 lg:px-0 container " style="padding-bottom: 0">
      <div class="md:mt-28 w-full">
        <div class="text-left mx-6 md:mx-0 flex md:block w-full">
          <Back to="loan-simulator" class="mt-1 md:mt-0" />
          <div class="block md:hidden">
            <div class="steps__title--mobile">
              {{ $t('proposal.fiscal_years.title_mobile') }}
            </div>
  
          </div>
        </div>
        <div class="block md:hidden w-full px-6">
          <div class="steps__progress-bar">
            <div class="steps__progress-bar__completed" :style="'width:40%'"></div>
          </div>
        </div>
  
        <div class="relative w-full h-full">
          <div class="hidden md:block absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <GreenBall class="opacity-10 w-80" start="bottom" offset="-15rem" cutout="130" />
          </div>
          <div class="hidden md:block absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <GreenBall class="opacity-10 w-32" start="bottom" offset="15rem" cutout="-130" />
          </div>
          <div style="border-radius: 3rem"
            class="h-full md:h-auto flex flex-col justify-between md:block scale-100 md:fixed md:max-w-xl md:bg-white md:top-1/2 transition-all md:left-1/2 transform md:-translate-x-1/2 md:-translate-y-1/2 z-50 py-12 px-6 md:px-16">
            <div>
              <div class="text-sm md:text-lg text-grey-2 md:font-medium text-left md:text-center">
                {{ $t('proposal.fiscal_years.title') }}
              </div>
  
              <div class="text-grey-3 mt-6">
                <GeneralInput v-model:data="fiscalYears" separatedRadio bgColor="bg-white md:bg-grey-ghost" type="radio"
                  name="status" :options="$tm('proposal.fiscal_years.options')" />
              </div>
            </div>
            <div class="w-full mt-6"  style="padding-bottom: calc(var(--sab) + 24px);">
              <GpButton class="mx-auto" :disabled="fiscalYears == undefined" @click="submit">
                {{ $t('proposal.fiscal_years.btn') }}
              </GpButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Back from '@/components/general/Back.vue';
  import GpButton from '@/components/general/GpButton.vue';
  import GreenBall from '@/components/general/GreenBall.vue';
  import GeneralInput from '@/components/general/Input.vue';
  import { ref, onBeforeMount } from 'vue';
  import { useRouter } from 'vue-router';
  import { useStore } from 'vuex';
  
  
  
  export default {
    components: {
      Back,
      GeneralInput,
      GpButton,
      GreenBall
    },
    setup() {
      const fiscalYears = ref(null)
      const router = useRouter()
      const store = useStore()
  
      function submit(){
        store.dispatch('setFormData', {'two_fiscal_years': fiscalYears.value === 'yes'})
        router.push('/proposal/form')
      }
  
      onBeforeMount(() =>{
        if(!('amount' in store.state.general.formData) || !('term_months' in store.state.general.formData))
          router.push('/loan-simulator')
      })
  
      return {
        fiscalYears,
        submit
      }
  
    }
  }
  </script>
  
  <style></style>
  